"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVideoProperty = exports.videoPropertyDefinition = void 0;
exports.videoPropertyDefinition = {
    view: {
        label: 'Video',
        style: 'media-preview',
    },
    constraints: [
        {
            name: 'stencils',
            argument: [
                'episode-video',
                'film',
                'live-video',
                'recap-video',
                'trailer-video',
                'video',
                'video-vr-360',
            ],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'video',
};
const isVideoProperty = (prop) => {
    return prop.name === exports.videoPropertyDefinition.name;
};
exports.isVideoProperty = isVideoProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmlkZW8ucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy92aWRlby5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLHVCQUF1QixHQUFHO0lBQ3JDLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxPQUFPO1FBQ2QsS0FBSyxFQUFFLGVBQWU7S0FDdkI7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRTtnQkFDUixlQUFlO2dCQUNmLE1BQU07Z0JBQ04sWUFBWTtnQkFDWixhQUFhO2dCQUNiLGVBQWU7Z0JBQ2YsT0FBTztnQkFDUCxjQUFjO2FBQ2Y7U0FDRjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE9BQU87SUFDYixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxPQUFPO0NBQ2tCLENBQUE7QUFJMUIsTUFBTSxlQUFlLEdBQUcsQ0FBQyxJQUFrQixFQUF5QixFQUFFO0lBQzNFLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSywrQkFBdUIsQ0FBQyxJQUFJLENBQUE7QUFDbkQsQ0FBQyxDQUFBO0FBRlksUUFBQSxlQUFlLG1CQUUzQiJ9